module.exports = __webpack_public_path__ + "static/media/info.7285bcc5.mp3";